import { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import ZonaCargando from "../alertas/zonaCargando";
import ListaPagos from "../../componentesEspeciales/pagosAdmin/listaPagos";
import { formatearMoneda } from "../../funcionesDatos/Moneda";

function fmt(n) { return formatearMoneda(Number(n || 0), "COP"); }

const TABS_DESEMBOLSO = [
    { key: "todos",      label: "Todos" },
    { key: "pendiente",  label: "Pendiente" },
    { key: "programado", label: "Programado" },
    { key: "pagado",     label: "Pagado" },
    { key: "retenido",   label: "Retenido" },
];

const TABS_PERIODO = [
    { key: "",    label: "Todo" },
    { key: "hoy", label: "Hoy" },
    { key: "7d",  label: "7 días" },
    { key: "30d", label: "30 días" },
    { key: "90d", label: "90 días" },
];

function PagosRecibidos() {
    const { cargandoUsuario } = useOutletContext() || {};

    const [pagos, setPagos]       = useState([]);
    const [total, setTotal]       = useState(0);
    const [paginas, setPaginas]   = useState(1);
    const [resumen, setResumen]   = useState(null);
    const [cargando, setCargando] = useState(false);

    const [pagina, setPagina]               = useState(1);
    const [tabDesembolso, setTabDesembolso] = useState("todos");
    const [periodo, setPeriodo]             = useState("");
    const [busqueda, setBusqueda]           = useState("");
    const [busquedaInput, setBusquedaInput] = useState("");

    useEffect(() => {
        if (cargandoUsuario) return;
        let activo = true;
        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/listar-pagos-admin", {
                    params: { pagina, estadoDesembolso: tabDesembolso, periodo, busqueda },
                });
                if (activo && res.data.exito) {
                    setPagos(res.data.pagos || []);
                    setTotal(res.data.total || 0);
                    setPaginas(res.data.paginas || 1);
                    setResumen(res.data.resumen || null);
                }
            } catch (err) {
                console.log("Error cargando pagos admin:", err);
            } finally {
                if (activo) setCargando(false);
            }
        })();
        return () => { activo = false; };
    }, [cargandoUsuario, pagina, tabDesembolso, periodo, busqueda]);

    function cambiarTab(key) { setTabDesembolso(key); setPagina(1); }
    function cambiarPeriodo(key) { setPeriodo(key); setPagina(1); }

    function buscar(e) {
        e?.preventDefault?.();
        setBusqueda(busquedaInput.trim());
        setPagina(1);
    }

    function limpiarBusqueda() {
        setBusquedaInput("");
        setBusqueda("");
        setPagina(1);
    }

    if (cargandoUsuario) return <ZonaCargando />;

    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <h1 className="h2 text-dark mb-1">Pagos recibidos</h1>
                <p className="text-muted mb-0 small">Reservas con pago aprobado por el comprador.</p>
            </div>

            {resumen && (
                <div className="row g-3 mb-4">
                    {[
                        { label: "Total recaudado",      value: fmt(resumen.totalRecaudado),    icon: "bi-cash-coin",       color: "var(--azul-bootstrap-cta)" },
                        { label: "Comisión Zervicy",     value: fmt(resumen.totalComision),     icon: "bi-percent",         color: "var(--verde-bootstrap)" },
                        { label: "Neta a vendedores",    value: fmt(resumen.totalNetaVendedor), icon: "bi-people-fill",     color: "var(--violeta-bootstrap)" },
                        { label: "Urgencias cobradas",   value: fmt(resumen.totalUrgencias),    icon: "bi-lightning-fill",  color: "var(--rojo-error)" },
                        { label: "Pendiente desembolso", value: fmt(resumen.totalPendiente),    icon: "bi-hourglass-split", color: "var(--naranja-mapa)" },
                        { label: "Desembolsado",         value: fmt(resumen.totalPagado),       icon: "bi-bank2",           color: "var(--verde-teal-bs)" },
                    ].map(({ label, value, icon, color }) => (
                        <div key={label} className="col-6 col-md-4 col-xl-2">
                            <div className="card border-0 shadow-sm rounded-4 h-100">
                                <div className="card-body p-3 p-md-4">
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                        <i className={`bi ${icon}`} style={{ color, fontSize: "1.1rem" }}></i>
                                        <span className="text-secondary small fw-semibold">{label}</span>
                                    </div>
                                    <div className="fw-bold text-dark" style={{ fontSize: "1.1rem" }}>{value}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="d-flex flex-column flex-md-row gap-3 mb-4 align-items-md-center flex-wrap">
                <div className="d-flex gap-1 flex-wrap">
                    {TABS_DESEMBOLSO.map(t => (
                        <button
                            key={t.key}
                            type="button"
                            className={`btn btn-sm rounded-pill px-3 ${tabDesembolso === t.key ? "btn-dark" : "btn-outline-secondary"}`}
                            onClick={() => cambiarTab(t.key)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                <div className="d-flex gap-1 flex-wrap">
                    {TABS_PERIODO.map(t => (
                        <button
                            key={t.key}
                            type="button"
                            className={`btn btn-sm rounded-pill px-3 ${periodo === t.key ? "btn-primary" : "btn-outline-secondary"}`}
                            onClick={() => cambiarPeriodo(t.key)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                <form className="d-flex gap-2 ms-md-auto" onSubmit={buscar}>
                    <div className="input-group shadow-sm" style={{ minWidth: 240 }}>
                        <input
                            type="text"
                            className="form-control rounded-start-pill border-end-0"
                            placeholder="Servicio, comprador, vendedor..."
                            value={busquedaInput}
                            onChange={e => setBusquedaInput(e.target.value)}
                        />
                        {busquedaInput && (
                            <button type="button" className="btn btn-outline-secondary border-start-0 border-end-0" onClick={limpiarBusqueda}>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        )}
                        <button type="submit" className="btn btn-dark rounded-end-pill px-3">
                            <i className="bi bi-search"></i>
                        </button>
                    </div>
                </form>
            </div>

            {cargando ? (
                <div className="text-center py-5">
                    <span className="spinner-border text-primary" role="status" />
                </div>
            ) : (
                <ListaPagos
                    pagos={pagos}
                    total={total}
                    pagina={pagina}
                    paginas={paginas}
                    onPagina={p => setPagina(p)}
                />
            )}
        </div>
    );
}

export default PagosRecibidos;
